module.exports = __webpack_public_path__ + "img/ellipse.4a00d789.svg";